<template>
  <div>
    <v-dialog v-model="dialog" width="500" >
      <v-sheet>
        <ItemForm :types="types" @submited="updateItemAfterChange($event)" :update-item="updateItem"></ItemForm>
      </v-sheet>
    </v-dialog>

    <v-dialog v-model="dialogNewProduct" width="500" >
      <v-sheet>
        <New :types="types" @created="dialogNewProduct=false" style="padding: 1rem"></New>
      </v-sheet>
    </v-dialog>

    <v-btn @click="dialogNewProduct=true" color="green" >
      <v-icon>add</v-icon>
    </v-btn>
    <v-btn   color="blue" :to="{ name : 'storage-type' }">
      <v-icon>category</v-icon>
    </v-btn>
    <v-btn    :to="{ name : 'storage-history' }">
      <v-icon>history</v-icon>
    </v-btn>

    <v-layout wrap>
      <v-flex  xs12 sm12 md8 lg8>
        <h2 style="display: block; margin-top: 1.5rem">Produkty na magazynie:</h2>
      </v-flex>
      <v-flex xs12 sm12 md4 lg4>
        <v-text-field @change="search($event)" label="Szukaj"></v-text-field>
      </v-flex>
    </v-layout>

    <v-data-table :loading ="loading" :headers=" headers" :items="products" class="elevation-10">
      <template v-slot:items="props">
        <td>{{ props.item.id }}</td>
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.description }}</td>
        <td>{{ props.item.storage_type.name }}</td>
        <td>{{ props.item.quantity }}</td>
        <td>
          <v-btn small icon>
            <v-icon color="primary"  fab block @click="prepareToUpdateProduct(props.item)">edit</v-icon>
          </v-btn>
          <v-btn small icon>
            <v-icon  fab block @click="deleteProduct(props.item.id)">delete</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import ItemForm from "@/components/storage/ItemForm";
import New from "@/components/storage/New";
import Messenger from "@/plugins/Messenger";
export default {
  name: "Index",
  components: {New, ItemForm},
  data(){
    return{
      dialogNewProduct:false,
      dialog: false,
      loading: false,
      updateItem : null,
      products : [],
      types : [],
      allProducts : [],
      headers:[
        {
          text: 'ID',
          value: "id",
        },
        {
          text: this.$t('archive.name'),
          value: 'name'
        },
        {
          text: this.$t('department.description'),
          value: 'description'
        },
        {
          text: this.$t('base.type'),
          value: 'type'
        },
        {
          text: 'Ilość',
          value: 'quantity'
        },
        {
          text: "Akcje"
        }
      ]
    }
  },
  methods:{
    updateItemAfterChange(form){
      if(!form.valid){
        return
      }

      let postData = {
        'name' : form.name,
        'description' : form.description,
        'quantity' : form.quantity,
        'storage_type_id' : form.type.id
      }

      this.$http.put('storage/' + this.updateItem.id, postData).then(()=>{
        Messenger.emitSuccess("Zaktualizowano produkt")
        let item = this.products.find(item => item.id == this.updateItem.id)
        item.name = form.name
        item.description = form.description
        item.quantity = form.quantity
        this.$router.push('/storage')
      }).catch(()=>{
        Messenger.emitError("Nie można zaktualizować produktu")
      })

    },
    prepareToUpdateProduct(item){
      this.updateItem = item
      this.dialog = true
    },
    search(text){
      if(text==""){
        this.products = this.allProducts
      }

      text = text.toLowerCase()
      this.products = this.allProducts.filter(product =>
          product.name.toLowerCase().includes(text) || product.description.toLowerCase().includes(text))
    },
    deleteProduct(id){
      this.$confirm("Jesteś pewien?").then(res=>{
        if(res){
          this.products = this.products.filter(el => el.id != id)
          this.$http.delete('/storage/' + id).catch(()=>{
            Messenger.emitError("Nie można usunąć produktu")
          })
        }
      })
    }
  },
  created() {
    this.loading = true
    Promise.all([this.$http.get('/storage'), this.$http.get('/storage/types')]).then(data=>{
      this.products = data[0].data
      this.allProducts = data[0].data
      this.types = data[1].data
      this.loading = false
    }).catch(()=>{
      Messenger.emitError("Nie można pobrać danych")
    })
  }
}
</script>

<style scoped>

</style>